const REQUIRED_ENV_VARS = [
  'VITE_AZURE_AD_CLIENT_ID',
  'VITE_AZURE_AD_TENANT_ID',
  'VITE_AZURE_API_SCOPE',
  'VITE_CONTROL_CENTRE_API_DOMAIN',
  'VITE_CONTROL_CENTRE_V2_API_DOMAIN',
] as const

const raw = { ...import.meta.env, ...window['env'] }

const missing = REQUIRED_ENV_VARS.filter((key) => !raw[key])
if (missing.length > 0)
  throw new Error(
    `Missing required environment variables: ${missing.join(', ')}`,
  )

export const env = raw as typeof raw &
  Record<(typeof REQUIRED_ENV_VARS)[number], string>
